import React from 'react';
import { connect } from 'react-redux';
import { shape, string } from 'prop-types';

import { getUrl } from 'Jsx/Catalog/components/FiltersV2/redux/selectors';

class Slug extends React.Component {
  componentDidUpdate() {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(this.setUrl);
    } else {
      setTimeout(() => {
        this.setUrl();
      }, 1);
    }
  }

  setUrl = () => {
    const { state } = this.props;
    const actualPath = window.location.pathname + window.location.search;
    const newUrl = getUrl(state);

    if (actualPath !== newUrl) {
      window.history.replaceState(null, null, newUrl);
    }
  };

  render() {
    return null;
  }
}

Slug.propTypes = {
  state: shape({
    filters: shape({}).isRequired,
    countryPrefix: string,
  }).isRequired,
};

export default connect(state => ({ state }))(Slug);
